'use client'

import { useEffect } from 'react'
import { find } from 'lodash'
import { useRouter, usePathname } from '@/lib/next-shim'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { Consultation } from '@/core/graphql/types'
import { useIsFranceMode } from '@/hooks/useIsFranceMode'
import { isPatientReady } from '@/utils/profile-readiness'
import { useRequiredParams } from '@/hooks/useRequiredParams'

export function useConsultationLivePage() {
  const { consultationId } = useRequiredParams(['consultationId'])
  const router = useRouter()
  const pathname = usePathname()
  const isFrance = useIsFranceMode()

  const { data, loading, error, refetch } = useGetMyInfosQuery()
  const myInfos = data?.myInfos
  const ready = isPatientReady(myInfos, isFrance)

  // Backstop for the waiting-room gate: never start a billable video consultation for an
  // incomplete (France: missing NIR) profile.
  useEffect(() => {
    if (loading || error) return
    if (myInfos && !ready) {
      const back = pathname || `/account/consultations/${consultationId}/live`
      router.replace(`/complete-profile?callbackUrl=${encodeURIComponent(back)}`)
    }
  }, [myInfos, ready, loading, error, pathname, consultationId, router])

  const consultation = ready ? (find(myInfos?.consultations, { _id: consultationId }) as Consultation | undefined) : undefined

  return {
    loading,
    error,
    refetch,
    ready,
    consultation,
    patientId: myInfos?._id ?? '',
  }
}
